import {Component, OnInit, ViewChild} from '@angular/core';
import {AuthService} from '../../service/auth/auth.service';
import {MatMenuTrigger} from '@angular/material/menu';

@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.css']
})
export class UserMenuComponent {

  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;


  constructor(public authService: AuthService) {
  }

  triggerMenu() {
    this.trigger.openMenu();
  }
}
